export default {
      id: "list-view-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#list-view-usage",
      toString: function () {
        return this.url;
      }
    }